import { createContext } from 'react'

export const GoBackToContext = createContext<string>('')
